import { render, staticRenderFns } from "./super-admin-new-tenant-form.vue?vue&type=template&id=59aba429&scoped=true&"
import script from "./super-admin-new-tenant-form.vue?vue&type=script&lang=ts&"
export * from "./super-admin-new-tenant-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aba429",
  null
  
)

export default component.exports